import React, { memo } from "react";
import { StyleTag } from "seed/helpers"


const ProfileIcon = memo(function ProfileIconComponent({
  className = "",
  style,
}) {
  return (
    <svg viewBox="0 0 600 600"
      className={className + " profile-icon-0"} style={style}>

      <StyleTag content={`
      .profile-icon-0 { fill: #fff; }
      .profile-icon-1 { fill: #c7cdd7; }
    `} />

      <defs>
        <clipPath id="circular-border">
          <circle cx="300" cy="300" r="300" />
        </clipPath>
        <clipPath id="avoid-antialiasing-bugs">
          <rect width="100%" height="498" />
        </clipPath>
      </defs>

      <circle className="profile-icon-1" cx="300" cy="300" r="300" clipPath="url(#avoid-antialiasing-bugs)" />
      <circle cx="300" cy="230" r="115" />
      <circle cx="300" cy="550" r="205" clipPath="url(#circular-border)" />
    </svg>)
});

export default ProfileIcon;